module.exports = __webpack_public_path__ + "9f3ca32875c24e689bee743e25195b63.pdf";